import React from 'react';
import { Input, Grid, Button, Icon, Dropdown } from 'semantic-ui-react';
import DeleteIcon from '@material-ui/icons/Delete';
import $ from "jquery";
import Mrp from '../../Sales/Quotation/relatedinfo';

class Title extends React.Component {

  state= {
    selected: '', brandOptions: [], parts: [], partcodeOption: []
  }

  componentDidMount() {
    let context = this;
    $("#stock"+context.props.count).keyup(function(event) {
      if (event.keyCode === 13) { context.props.addButton(); }
    });
  }

  partcode = event => {
    let val = event.target.value; let partno = val.split('->')[2];
    let brandname = val.split('->')[3]; this.getPartsAndBrand(partno, brandname);
  };

  getPartsAndBrand(partno, brandname) {
    let context = this;
    let data = this.props.data;
    let brand_id, partname, mrp, tax, ava_stocks, frombanchstock, aliasId, value, dnp;
    data.map((z) => {
      if (z.partno == partno && z.brand_name == brandname) {
        brand_id = z.brand_id; partname = z.spare_name; ava_stocks = z.ava_stocks;
        value = z.part_alias; mrp = z.mrp; tax = z.tax; frombanchstock = z.frombanchstock;
        aliasId = z.id; dnp = z.dnp;
      }
    })
    context.props.addArray(context.props.id, aliasId, value, partno, value, ava_stocks, brand_id, partname, brandname, mrp, tax, frombanchstock, dnp);
  }

  onChange = (type) => (f, { value }) => {
    if (this.props.from == 'REQUEST') {
      let frombanchstock = 0; let stock = 0;
      try {
        frombanchstock = Number(this.props.item.stocksAvailables);
        stock = Number(value);
      } catch (e) {
      }
      if (frombanchstock < stock) {
        alert('There is '+frombanchstock+' stock`s are available!!!' );
        return;
      }
      console.log(this.props.item);
      this.props.updateItem(this.props.id, type, value);
    }
    else {
      if (type == 'stocks') {
        let frombanchstock = 0; let stock = 0;
        try {
          frombanchstock = Number(this.props.item.frombanchstock);
          stock = Number(value);
        } catch (e) {
        }
        if (frombanchstock < stock) {
          alert('There is '+frombanchstock+' stock`s are available!!!' );
          return;
        }
        else { this.props.updateItem(this.props.id, type, value); }
      }
      else {
        this.props.updateItem(this.props.id, type, value);
      }
    }
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  render() {
    let mrp = this.props.item.mrp;
    if (this.props.type == 'DNP') {
      mrp = this.props.item.dnp;
    }
    let tax = this.props.item.tax;
    let stocks = this.props.item.stocks;
    let discount = this.props.item.discount;
    tax = this.convertToNumber(tax);
    discount = this.convertToNumber(discount);
    mrp = this.convertToNumber(mrp);
    let total = mrp * stocks;
    let stocksAvailable = this.props.item.stocksAvailables;
    let taxablePrice = total + ((total * tax)/100);
    if (this.props.type == 'MRP') {
      mrp = mrp - ((mrp * discount)/100);
      taxablePrice = taxablePrice - ((taxablePrice * discount)/100);
    }
    mrp = this.makeDecimalPoint(mrp);
    taxablePrice = this.makeDecimalPoint(taxablePrice);
    return (
      <tbody>
        <tr>
          <td><center>{this.props.count}</center></td>
          <td>
            <center>
              <datalist id="suggestions">
                  {this.props.partOption.map((x) => {
                    return (
                      <option>{x.part_alias+'->'+x.spare_name+'->'+x.partno+'->'+x.brand_name}</option>
                    )
                  })}
              </datalist>
              <input style={{height: 35}} onChange={this.partcode} autoComplete="on"
              list="suggestions" value={this.props.item.partno} id={this.props.id}/>
            </center>
          </td>
          <td><center>{this.props.item.partname}</center></td>
          <td><center>{this.props.item.brand_name}</center></td>
          <td>
          { this.props.from != 'REQUEST' && this.props.type == 'MRP' ?
            (
              <center>
                <Input fluid focus type='number' value={this.props.item.stocks} placeholder={this.props.item.frombanchstock}
                id={'stock'+this.props.count} onChange={this.onChange('stocks')} />
              </center>
            ):
            (
              <center>
                <Input fluid focus type='number' value={this.props.item.stocks} placeholder={this.props.item.stocksAvailables}
                id={'stock'+this.props.count} onChange={this.onChange('stocks')} />
              </center>
            )
          }

          </td>
          { this.props.from != 'REQUEST' && this.props.type == 'MRP' ?
            (
              <td>
                <center>
                  <Input fluid focus value={this.props.item.discount}
                    placeholder={'Dis(%)'}
                    id={'discount'+this.props.count} onChange={this.onChange('discount')} />
                </center>
              </td>
            ): ''
          }
          { this.props.from != 'REQUEST' && this.props.type == 'MRP' ?
            (
              <td>
                <center>
                  <Input fluid focus value={this.props.item.discountrs}
                    placeholder={'Dis(Rs)'}
                    id={'discount'+this.props.count} onChange={this.onChange('discountrs')} />
                </center>
              </td>
            ): ''
          }
          <td><center>{mrp}</center></td>
          <td><center>{tax}</center></td>
          <td><center>{taxablePrice}</center></td>
          <td>
            <div style={{display: 'flex'}}>
              <DeleteIcon onClick={this.props.remove(this.props.id)} style={{cursor: 'pointer', paddingTop: '2%'}} />
              <Mrp viewDisplay='none' partno={this.props.item.partno} partcodeOption={this.props.partOption}
                   aliasId={this.props.item.aliasId} brand_id={this.props.item.brand} />
            </div>
          </td>
        </tr>
      </tbody>
    );
  }
}

export default Title;
